import {
  GET_THRIWE_PRIME_BOOKING_EMPTY,
  GET_THRIWE_PRIME_BOOKING_ERROR,
  GET_THRIWE_PRIME_BOOKING_LIST,
  GET_THRIWE_PRIME_BOOKING_SUCCESS,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ThriwePrimeBookingList = (state = initialState, action) => {
  switch (action.type) {
    case GET_THRIWE_PRIME_BOOKING_LIST:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_THRIWE_PRIME_BOOKING_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_THRIWE_PRIME_BOOKING_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_THRIWE_PRIME_BOOKING_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ThriwePrimeBookingList;
